import { useState, useEffect } from 'react';

export const getAppLayoutHeaderBottom = (): number => {
    const appHeader = document.querySelector<HTMLElement>('.ant-layout-header');
    return Math.max(appHeader?.getBoundingClientRect().bottom ?? 60, 60);
};

/**
 * Live bottom edge (viewport Y) of the main app header, for aligning
 * `position: sticky` toolbars and thresholds with the real header height.
 */
const useAppLayoutHeaderBottom = (): number => {
    const [headerBottom, setHeaderBottom] = useState(() =>
        getAppLayoutHeaderBottom(),
    );

    useEffect(() => {
        const read = () => {
            const next = getAppLayoutHeaderBottom();
            setHeaderBottom(prev =>
                Math.abs(prev - next) < 0.5 ? prev : next,
            );
        };

        read();

        const appHeader = document.querySelector<HTMLElement>(
            '.ant-layout-header',
        );
        const resizeObserver = new ResizeObserver(read);

        if (appHeader) resizeObserver.observe(appHeader);

        // Capture so we run when any nested scroll container scrolls (not only the window).
        document.addEventListener('scroll', read, { passive: true, capture: true });
        window.addEventListener('resize', read);

        return () => {
            resizeObserver.disconnect();
            document.removeEventListener('scroll', read, true);
            window.removeEventListener('resize', read);
        };
    }, []);

    return headerBottom;
};

export default useAppLayoutHeaderBottom;
